import styled from 'styled-components';
import { ProductiveHeading03, BodyLong01 } from 'components/styles';

const Title = styled.div`
  ${ProductiveHeading03};
`;
const Description = styled.div`
  ${BodyLong01};
`;

const Actions = styled.div``;

const FeatureContent = styled.div`
  position: relative;
  ${Title} {
    margin-bottom: var(--spacing-04);
    max-width: 70%;
  }
  ${Description} {
    margin-bottom: var(--spacing-08);
    max-width: 70%;
  }
  ${Actions} {
    position: absolute;
    right: 0;
    top: 0;
  }
`;

type Content = typeof FeatureContent & {
  Title: typeof Title;
  Description: typeof Description;
  Actions: typeof Actions;
};

const Content: Content = FeatureContent as any;

Content.Title = Title;
Content.Description = Description;
Content.Actions = Actions;

export { Content };
